import React from 'react'
import { Model, WhenModel } from '@morningtrain/react-resources'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import { useEnvValue, WhenEnvValueMatches } from '@morningtrain/react-helpers'
import EmployeeOnboardingListView from 'pages/app/onboarding/partials/EmployeeOnboardingListview'
import AdminPage from 'pages/app/AdminPage'
import EmployeeOnboardingListInstance from 'pages/app/onboarding/partials/EmployeeOnboardingListInstance'
import ModelValueTitle from 'widgets/ModelValueTitle'
import BackToOverview from 'widgets/navigation/BackToOverview'

export default function EmployeeOnboardingOverview () {
  const [myId] = useEnvValue('user.id')
  const [routeUserId] = useEnvValue('router.currentParameters.user')

  const userId = routeUserId || myId
  const isMine = myId === userId

  const [focusedOnboarding, setFocusedOnboarding] = useEnvValue('onboarding.focused_list', null)

  React.useEffect(() => {
    setFocusedOnboarding(null)

    return () => {
      setFocusedOnboarding(null)
    }
  }, [])

  return (
    <AdminPage>
      <Translator namespace='onboarding'>

        <Model resourceName='onboarding.onboarding_checklists' operationName='employee' id={userId} clean>
          <WhenModel>
            <UI.PageHeader title={<ModelValueTitle name='user.name'/>}>
              <BackToOverview
                route='app.onboarding.overview'>
                <Translation name='actions.back_to_overview'/>
              </BackToOverview>
            </UI.PageHeader>
            <WhenEnvValueMatches name='onboarding.focused_list' matches={v => v === null}>
              <EmployeeOnboardingListView/>
            </WhenEnvValueMatches>
            <WhenEnvValueMatches name='onboarding.focused_list' matches={v => v === null} negate>
              <EmployeeOnboardingListInstance isMine={isMine}/>
            </WhenEnvValueMatches>
          </WhenModel>
        </Model>

      </Translator>
    </AdminPage>
  )
}
